// extracted by mini-css-extract-plugin
export default {"rightAlign":"addEntities_rightAlign__yQOQm","upperCase":"addEntities_upperCase__2nVpC","capitalize":"addEntities_capitalize__Fjy3h"};